import { useDisplayName } from '~/hooks/useDisplayName'
import { usePrivacyMode } from '~/hooks/usePrivacyMode'
import { HIDDEN_ADDRESS } from '~/store/privacyModeStore'
import { IAddress } from '~/types'
import { shortenAddress, shortenENS } from '~/utils/addresses'

export const ShortenedEnsOrAddress = ({ address }: { address: IAddress }) => {
  const { ens } = useDisplayName(address)
  const isPrivacyModeOn = usePrivacyMode()
  if (isPrivacyModeOn) {
    return <span className="min-w-0 truncate">{HIDDEN_ADDRESS}</span>
  }
  return (
    <span className="min-w-0 truncate">
      {ens ? shortenENS(ens) : shortenAddress(address, 4, 4)}
    </span>
  )
}
